module.exports = "<div class=\"checkout-help\"> <div class=\"checkout-help__title\" translate=\"CHECKOUTHELP.QUESTIONS\"></div> <div class=\"checkout-help__desc\" translate=\"CHECKOUTHELP.NEEDHELP\"></div> <div class=\"checkout-help__phone\"> <md-icon>phone</md-icon> <span translate=\"CHECKOUTHELP.PHONENUMBER\"></span> </div> <md-button ng-click=\"$ctrl.launchIntercom()\" class=\"checkout-help__button checkout-rounded-button\" md-no-ink> <md-icon>message</md-icon> <span translate=\"CHECKOUTHELP.CHATNOW\"></span> </md-button> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/checkout/components/help/help.html
// module id = 1282
// module chunks = 28